import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { storeButtons } from '../../../data';
import googleAnalytics from '../../../utils/googleAnalytics';
import classes from './AppStoreButton.module.css';

const AppStoreButton = ({ links }) => {
  const hub = useSelector((state) => state.hub.hub);

  return (
    <div className={classes.container}>
      {storeButtons.map((element) => (
        <a
          key={element.id}
          className={classes.appStoreButtonLink}
          href={links[element.id]}
          target="_blank"
          rel="noreferrer"
          onClick={() =>
            googleAnalytics({
              event: 'outboundLink',
              link_url: links[element.id],
              link_title: element.id,
              section_title: hub.name,
            })
          }
        >
          <img
            alt="app-Button"
            src={element.srcImage}
            className={classes.appStoreButton}
          />
        </a>
      ))}
    </div>
  );
};

AppStoreButton.propTypes = {
  links: PropTypes.shape({
    googlePlay: PropTypes.string,
    appStore: PropTypes.string,
  }).isRequired,
};

export default AppStoreButton;
